<template>
  <div>
    <div class="icon-nav">
      <ul>
        <li class="onhover-div mobile-cart">
          <router-link :to="{ path: '/shop'}" class="footer-shop">
            <div class="text-center">
              <font-awesome-icon icon="fa-solid fa-shop" />
            </div>
            <h6 class="cart-label text-center">Shop</h6>
          </router-link>
          <router-link :to="{ path: '/shop/cart'}" class="footer-bag">
            <div class="text-center">
              <img alt :src='"@/assets/images/icon/layout4/cart.png"' class="img-fluid cart-bag">
              <font-awesome-icon icon="fa-solid fa-cart-shopping" />
              <span class="cart_qty_cls">{{cart_qty}}</span>
            </div>
            <h6 class="cart-label text-center">My Bag</h6>
          </router-link>
          <!--
          <ul class="show-div shopping-cart" v-if="!cart.length">
            <li>Your cart is currently empty.</li>
          </ul>
          <div v-show="isShow" class="close-circle">
            <a href="#" @click="isShow = false" style="position:absolute;top:-280px;z-index:110;right:-270px;">
              <i class="fa fa-times" id="cart-menu-times" aria-hidden="true"></i>
            </a>
          </div>
          <ul id = "mobile-cart-menu" class="show-div shopping-cart" v-show="isShow" style="box-shadow: rgb(141, 141, 141) 0px 0px 5px;" v-if="cart.length">
            <li class="li_first" style="margin-top:5px;"></li>
            <li v-for="(item,index) in cart" :key="index">

              <template v-if="item.isrewarditem === 0">

                <div class="media">
                  <router-link :to="{ path: ''}">
                    <img
                        :src='require("@/assets/images/ajax-loader.gif")'
                        class="mr-3"
                    />
                    <img
                        :src='item.image_url_small'
                        class="mr-3 r-img"
                        :alt="item.desc"
                    />
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ path: ''}">
                      <h5 style="line-height:20px; margin-bottom:0px; width:80%;">{{item.desc}}</h5>
                    </router-link>
                    <div class="row" style="font-size:14px;">
                      <div class="col-6">Qty: {{item.qty}}</div>
                      <div class="col-6" style="text-align: right;">{{ item.single_price_show_incl_tax }}</div>
                    </div>
                    <div class="row" style="font-size:14px;">
                      <div class="col-8">Discount Code:</div>
                      <div class="col-4" style="text-align: right;">{{item.discount_code}}</div>
                    </div>
                    <div class="row" style="font-size:14px;">
                      <div class="col-6">Discount:</div>
                      <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show_incl_tax}}</div>
                    </div>
                  </div>
                </div>
                <div class="close-circle">
                  <a href="#" @click='removeCartItem(item)'>
                    <i class="fa fa-trash-o" style="margin-top:2px;transform: scale(1.4);" aria-hidden="true"></i>
                  </a>
                </div>

              </template>

              <template v-if="item.isrewarditem === 1">
                <div class="media">
                  <router-link :to="{ path: ''}">
                    <img
                        :src='require("@/assets/images/ajax-loader.gif")'
                        class="mr-3"
                    />
                    <img
                        :src='item.image_url_small'
                        class="mr-3 r-img"
                        :alt="item.desc"
                    />
                  </router-link>
                  <div class="media-body">
                    <router-link :to="{ path: ''}">
                      <h5 style="line-height:20px; margin-bottom:0px; width:80%;">{{item.desc}}</h5>
                    </router-link>
                    <div class="row" style="font-size:14px;">
                      <div class="col-6">Qty: {{item.qty}}</div>
                      <div class="col-6" style="text-align: right;">{{ item.single_price_show }}</div>
                    </div>
                    <div class="row" style="font-size:14px;">
                      <div class="col-12" style="text-align: right;">UNIBUD REWARD</div>
                    </div>
                    <div class="row" style="font-size:14px;">
                      <div class="col-6" style="text-align: right;">{{item.discount_qty_amount_show}}</div>
                    </div>
                  </div>
                </div>
              </template>

            </li>
            <li>
              <div class="total">
                <h5>
                  subtotal :
                  <span>{{ subTotal }}</span>
                </h5>
              </div>
            </li>
            <li>
              <div class="buttons">
                <router-link :to="{ path: '/shop/cart'}" :class="'view-cart'">
                  view cart
                </router-link>
                <router-link :to="{ path: '/shop/checkout'}" :class="'checkout'">
                  checkout
                </router-link>
              </div>
            </li>
          </ul>
          -->
        </li>
      </ul>
      <router-link :to="{ path: '/account/rewards'}">
        <div class="referals">
          <h6><font-awesome-icon icon="fa-solid fa-sack-dollar" /></h6>
          <h6 class="cart-label">Referrals</h6>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      currencyChange: {},
      search: false,
      searchString: '',
      isShow: false
    }
  },
  computed: {
    ...mapState({
      searchItems: state => state.products.searchProduct
    }),
    ...mapGetters({
      signedIn:'auth/signedIn',
      signedInName: 'auth/getFullName',
      cart: 'cart/cartItems',
      cartTotal: 'cart/cartTotalAmount',
      subTotal: 'cart/subTotalAmount',
      curr: 'products/changeCurrency',
      getDetail: 'products/getProductByProductId'
    }),
    cart_qty: function () {
      // Count all qty but exclude the reward counts
      let qty_count = 0;
      this.cart.forEach(item => {
        if(item.isrewarditem === 0) {
          qty_count += parseInt(item.qty, 10);
        }
      });
      return qty_count;
    },
  },
  methods: {
    openSearch() {
      // this.search = true
    },
    closeSearch() {
      this.search = false;
    },
    searchProduct() {
      this.$store.dispatch('products/searchProduct', this.searchString)
    },
    removeCartItem: function (cart) {
      this.$store.dispatch('cart/removeCartItem', cart)
    },
    updateCurrency: function (currency, currSymbol) {
      this.currencyChange = { curr: currency, symbol: currSymbol }
      this.$store.dispatch('products/changeCurrency', this.currencyChange)
    }
  }
}

</script>
